import React from 'react';
import { Navigate } from 'react-router-dom';
import { ADMIN_DEFAULT_ROUTE } from 'src/app/authentication/~store/actions/constants';
import { DEFAULT_ROUTE } from 'src/app/authentication/~store/actions/constants';
import IUser from 'src/app/authentication/~store/models/User';
import {UserRole} from 'src/app/authentication/~store/models/UserRole';
import { PermissionType } from '../user-context/models/PermissionType';

export const GuardedRoute  = (props: any) => {
    let { component: Component, roles, permissions, isAdminPermission, ...rest } = props;
    try {
        const user: IUser = JSON.parse(sessionStorage.getItem('user') ?? "");

        const adminPass = isAdminPermission != undefined && user.role === UserRole.Admin;

        permissions = permissions || [];
        
        if(user.isAuth &&
           (roles === undefined || roles.includes(user.role))) {
            if (user.permissions.filter(up => permissions.some((p: PermissionType) => up === p)).length > 0 || adminPass) {
                return <Component {...rest} />;
            }
            else if(user.role === UserRole.Admin){
                return <Navigate to={{pathname: ADMIN_DEFAULT_ROUTE}} />
            }
            else {
                return <Navigate to={{pathname: DEFAULT_ROUTE}} />
            }
        } else {
            sessionStorage.removeItem('user');
            return <Navigate to={{pathname: '/login'}} />;
        }
    } catch(ex) {
        return <Navigate to={{pathname: '/login'}}/>;
    }
  }